<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <div class="container" style="padding: 20px;">
      <!-- 第一部分：统计信息 -->
      <div style="margin-bottom: 10px; padding: 20px; background-color: #fff; border-radius: 8px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);">
        <div style="font-size: 16px; font-weight: bold; margin-bottom: 12px; color: #333;">
          设备占用统计
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 16px;">
          <div v-for="(item, index) in stats" :key="index" style="padding: 8px 16px;">
            <span style="font-weight: 500;">{{ item.provider }}</span>:
            <span style="font-weight: bold; color: #1890ff;">{{ item.used }}</span>台占用 / 
            <span style="font-weight: bold; color: #52c41a;">{{ item.idle }}</span>台空闲 / 
            <span style="font-weight: bold; color: #faad14;">{{ item.total }}</span>台总数
          </div>
        </div>
      </div>

      <!-- 第二部分：算力占用列表 -->
      <el-card class="box-card" style="margin-bottom: 20px;">
        <div slot="header" class="clearfix">
          <span style="font-size: 18px; font-weight: bold;">算力占用列表</span>
        </div>
        <!-- 搜索表单 -->
        <div class="search-form" style="margin-bottom: 20px;">
          <el-form :inline="true" :model="searchForm" size="small">
            <el-form-item label="提供商：">
              <el-input v-model="searchForm.provider" placeholder="请输入提供商" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item label="设备名称：">
              <el-input v-model="searchForm.hostname" placeholder="请输入设备名称" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item label="订单名称：">
              <el-input v-model="searchForm.order_name" placeholder="请输入订单名称" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table 
          :data="providers" 
          border 
          style="width: 100%"
        >
          <el-table-column 
            prop="dev_id" 
            label="设备ID" 
            sortable 
            width="180"
          />
          <el-table-column 
            prop="host_ip" 
            label="IP" 
            sortable
            width="140"
          />
          <el-table-column 
            prop="hostname" 
            label="设备名称" 
            sortable
            width="120"
          />
          <el-table-column 
            prop="provider" 
            label="提供商" 
            sortable
            width="120"
          />
          <el-table-column 
            prop="az_name" 
            label="可用区" 
            sortable
            width="130"
          />
          <el-table-column 
            prop="active_state" 
            label="状态" 
            sortable
            width="100"
          >
            <template #default="scope">
              <el-tag 
                :type="scope.row.status === 1 ? 'success' : scope.row.status === 2 ? 'warning' : 'info'"
                size="small"
              >
                {{ scope.row.status === 0 ? '空闲' : scope.row.status === 1 ? '占用' : '维护' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column 
            prop="order_name" 
            label="订单名称" 
            sortable 
          />
          <!-- <el-table-column 
            prop="order_id" 
            label="订单ID" 
            sortable
            width="180"
          /> -->
          <el-table-column 
            prop="delivery_time" 
            label="交付时间" 
            width="120"
            :formatter="formatDate" 
          />
          <el-table-column 
            prop="billing_start_time" 
            label="计费开始时间" 
            width="120"
            :formatter="formatDate" 
          />
          <el-table-column 
            prop="price" 
            label="单价" 
            sortable
            width="100"
          />
          <el-table-column 
            prop="metering_unit" 
            label="单位" 
            sortable
            width="100"
          />
        </el-table>
        <!-- 分页控件 -->
        <div class="pagination-wrapper" style="margin-top: 20px; text-align: right;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.page"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
          </el-pagination>
        </div>
      </el-card>
    </div>
  </d2-container>
</template>

<script>
import topLine from "@/components/save-common/topLine.vue";

export default {
  name: 'ComputingPowerOccupation',
  components: {
    topLine,
  },
  data() {
    return {
      pageTitle: "算力占用情况",
      stats: [],
      providers: [],
      searchForm: {
        provider: '',
        hostname: '',
        order_name: ''
      },
      pagination: {
        page: 1,
        pageSize: 10,
        pageSizeList: [10, 20, 50, 100],
        total: 0
      }
    };
  },
  created() {
    this.fetchDeviceStats();
    this.fetchProviders();
  },
  methods: {
    formatDate(row, column, cellValue) {
      const value = cellValue;
      if (!value) return '';
      return value.substring(0, 10);
    },
    async fetchDeviceStats() {
      try {
        const params = {
          provider: this.searchForm.provider,
          order_name: this.searchForm.order_name
        };
        const res = await this.$axios.get('/api-30216/api/user-provider/device-stats', { params });
        if (res.code === 200) {
          this.stats = Array.isArray(res.data) ? res.data : [];
        } else {
          this.$message.error('获取设备统计失败: ' + res.message);
        }
      } catch (err) {
        console.error('获取设备统计失败:', err);
      }
    },
    async fetchProviders() {
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          provider: this.searchForm.provider,
          hostname: this.searchForm.hostname,
          order_name: this.searchForm.order_name
        };
        const res = await this.$axios.get('/api-30216/api/user-providers', { params });
        if (res.code === 200) {
          this.providers = res.data || [];
          this.pagination.total = res.total || 0;
        } else {
          this.$message.error('获取设备列表失败: ' + res.message);
        }
      } catch (err) {
        console.error('获取设备列表失败:', err);
      }
    },
    handleSearch() {
      this.pagination.page = 1;
      this.fetchDeviceStats();
      this.fetchProviders();
    },
    handleReset() {
      this.searchForm = { 
        provider: '',
        hostname: '',
        order_name: '' 
      };
      this.pagination.page = 1;
      this.fetchDeviceStats();
      this.fetchProviders();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.fetchProviders();
    },
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.fetchProviders();
    }
  }
};
</script>

<style scoped>
.container {
  margin: 0 auto;
}
.clearfix {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}
.clearfix > span,
.clearfix > .el-tag {
  line-height: 24px;
}
</style>